import { action, thunk, Action, Thunk, createContextStore } from "easy-peasy";
import { ApolloClient, NormalizedCacheObject } from "@apollo/client";
import { designDatas } from "./__generated__/designDatas";
import { DESIGNDATAS } from "./query";

type DesignModel = {
  apolloClient: ApolloClient<object> | undefined;
  backgroundColor: string | null;
  baseColor: string | null;
  buttonColor: string | null;
  logoColor: string | null;
  mainSaleColor: string | null;
  textColor: string | null;
  isLoaded: boolean;

  setDesignDatas: Action<DesignModel, {
    backgroundColor: string | null;
    baseColor: string | null;
    buttonColor: string | null;
    logoColor: string | null;
    mainSaleColor: string | null;
    textColor: string | null;
  }>;

  setIsLoaded: Action<DesignModel, boolean>;

  initDesign: Thunk<
    DesignModel,
    void,
    { apolloClient: ApolloClient<NormalizedCacheObject> }
  >;
};

const designModel = (
  apolloClient: ApolloClient<object> | undefined
): DesignModel => ({
  apolloClient,
  backgroundColor: null,
  baseColor: null,
  buttonColor: null,
  logoColor: null,
  mainSaleColor: null,
  textColor: null,
  isLoaded: false,

  // actions
  setDesignDatas: action((state, payload) => {
    state.backgroundColor = payload.backgroundColor;
    state.baseColor = payload.baseColor;
    state.buttonColor = payload.buttonColor;
    state.logoColor = payload.logoColor;
    state.mainSaleColor = payload.mainSaleColor;
    state.textColor = payload.textColor;
  }),

  setIsLoaded: action((state, payload) => {
    state.isLoaded = payload;
  }),

  // thunks
  initDesign: thunk(async (actions, payload, { getState }) => {
    const apolloClient = getState().apolloClient;
    if (!apolloClient) return;

    try {
      const result = await apolloClient.query<designDatas>({
        query: DESIGNDATAS,
        fetchPolicy: 'network-only'
      });

      if (result.data && result.data.designDatas) {
        const {
          backgroundColor,
          baseColor,
          buttonColor,
          logoColor,
          mainSaleColor,
          textColor
        } = result.data.designDatas;

        actions.setDesignDatas({
          backgroundColor,
          baseColor,
          buttonColor,
          logoColor,
          mainSaleColor,
          textColor
        });
      }

      actions.setIsLoaded(true);
    } catch (e) {
      console.error('Error loading design data:', e);
      actions.setIsLoaded(true);
    }
  })
});

export default createContextStore(designModel, { name: "design" });
